import { ZTime } from "IZOX/STATIC";
import CalendarizoC from "./CalendarizoC";

/**
 * @typedef {Object} calendarizoparams
 * @property {String} [valDate] - Selected date in ISO format.
 * @property {String} [valStart] - Start date for range selection in ISO format.
 * @property {String} [valEnd] - End date for range selection in ISO format.
 * @property {String[]} [valDates] - Array of selected dates in ISO format.
 * @property {String} [minDate] - Minimum selectable date in ISO format.
 * @property {String} [maxDate] - Maximum selectable date in ISO format.
 * @property {Number} [minRange] - Minimum range for date selection.
 * @property {Number} [maxRange] - Maximum range for date selection.
 * @property {(date, rangeMode, curValue) => Boolean} [validFunc] - Function to validate selected date.
 * @property {"date" | "week" | "month" | "year"} [selectType] - Type of selection ("date", "range", etc.).
 * @property {Boolean} [range] - Whether to enable range selection.
 * @property {Boolean} [dayOfWeekBar] - Whether to show the day of week bar.
 * @property {Boolean} [weekendHighlight] - Whether to highlight weekends.
 * @property {Boolean} [directConfirm] - Whether to confirm selection directly.
 * @property {(date) => void | ({start, end}) => void} [onConfirm] - Callback function for confirmation.
 * @property {Function} [onCancel] - Callback function for cancellation.
 * @property {Number} [size] - Size of the calendar items.
 * @property {Object} [style] - Custom styles for the calendar.
 * @property {Number} [defaultDisMonth] - Default displayed month.
 * @property {Number} [defaultDisYear] - Default displayed year.
 * @property {Boolean} [readOnly] - Whether the calendar is read-only.
 * @property {Boolean} [multiple] - Whether to allow multiple date selections.
 * @property {(year: Number, month: Number) => void} [onSelectorChange] - Callback when month/year selector changes.
 * @property {(date: String, info: { isInRange: Boolean, isStart: Boolean, isEnd: Boolean, isSelected: Boolean }) => React.Component} [dayCellDecorator] - Function to decorate individual day cells.
 * 
 * @param {calendarizoparams} param0 
 * @returns 
 */
function Calendarizo({
  valDate = null,
  valStart = null,
  valEnd = null,
  valDates = [],
  
  minDate = ZTime.Moment(new Date(1970, 0, 1)).toISOString(),
  maxDate = ZTime.Moment(new Date(2200, 11, 31)).toISOString(),
  minRange = 0,
  maxRange = Infinity,
  validFunc = (date, rangeMode, curValue) => true,

  selectType = "date",
  range = false,

  dayOfWeekBar = true,
  weekendHighlight = true,

  directConfirm = true,

  onConfirm = null,
  onCancel = null,

  size = 40,
  style = {},

  defaultDisMonth = ZTime.Now().local().month(),
  defaultDisYear = ZTime.Now().local().year(),

  readOnly = false,
  multiple = false,

  onSelectorChange = null,
  dayCellDecorator = null
}) {
    // Calendarizo initialization code
  return (
    <CalendarizoC 
      valDate={valDate}
      valStart={valStart}
      valEnd={valEnd}
      valDates={valDates}
      minDate={minDate}
      maxDate={maxDate}
      minRange={minRange}
      maxRange={maxRange}
      validFunc={validFunc}
      selectType={selectType}
      range={range}
      dayOfWeekBar={dayOfWeekBar}
      weekendHighlight={weekendHighlight}
      directConfirm={directConfirm}
      onConfirm={onConfirm}
      onCancel={onCancel}
      size={size}
      style={style}
      defaultDisMonth={defaultDisMonth}
      defaultDisYear={defaultDisYear}
      readOnly={readOnly}
      multiple={multiple}
      onSelectorChange={onSelectorChange}
      dayCellDecorator={dayCellDecorator}
      />
  );
}

export default Calendarizo;